import React from 'react'
import { string } from 'prop-types'

const Label  = ({ children, htmlFor, className }) => (
  <label className={className} htmlFor={htmlFor}>
    {children}
    <style jsx>
      {`
        label {
          line-height: 2;
          font-size: 16px;
          font-weight: bolder;
        }
      `}
    </style>
  </label>
)

Label.propTypes = {
  htmlFor: string,
  className: string,
}

export default Label
